'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Snackbar = require('material-ui/Snackbar');

var _Snackbar2 = _interopRequireDefault(_Snackbar);

var _colors = require('material-ui/styles/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -*- mode: rjsx -*-


var ErrorReporting = function (_Component) {
    _inherits(ErrorReporting, _Component);

    function ErrorReporting(props) {
        _classCallCheck(this, ErrorReporting);

        var _this = _possibleConstructorReturn(this, (ErrorReporting.__proto__ || Object.getPrototypeOf(ErrorReporting)).call(this));

        _initialiseProps.call(_this);

        if (props.error) {
            props.onError(props.error, props.action);
        }
        return _this;
    }

    _createClass(ErrorReporting, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.error) {
                nextProps.onError(nextProps.error, nextProps.action);
            }
        }
    }, {
        key: 'getSnackbarProps',
        value: function getSnackbarProps() {
            var _this2 = this;

            return Object.keys(this.props).filter(function (name) {
                return _this2.exclusiveProps.indexOf(name) === -1;
            }).reduce(function (acc, name) {
                acc[name] = _this2.props[name];
                return acc;
            }, {});
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_Snackbar2.default, _extends({
                open: this.props.open,
                message: this.props.getMessage(this.props),
                autoHideDuration: this.props.autoHideDuration,
                style: this.props.style,
                contentStyle: this.props.style,
                bodyStyle: this.props.style,
                onRequestClose: this.onClose
            }, this.getSnackbarProps()));
        }
    }]);

    return ErrorReporting;
}(_react.Component);

ErrorReporting.defaultProps = {
    open: false,
    action: '',
    error: null,
    autoHideDuration: 10000,
    getMessage: function getMessage(props) {
        return props.error ? (props.action ? props.action + ': ' : '') + String(props.error) : '';
    },
    style: {
        backgroundColor: _colors.red900,
        color: _colors.grey50
    },
    contentStyle: {
        display: 'block',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    },
    onError: function onError(error) {
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        return undefined;
    },
    onClose: function onClose(reason, error) {
        var action = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        return undefined;
    }
};
ErrorReporting.propTypes = {
    open: _propTypes2.default.bool,
    action: _propTypes2.default.string,
    error: _propTypes2.default.instanceOf(Error),
    autoHideDuration: _propTypes2.default.number,
    getMessage: _propTypes2.default.func,
    style: _propTypes2.default.object,
    contentStyle: _propTypes2.default.object,
    onError: _propTypes2.default.func,
    onClose: _propTypes2.default.func
};

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.exclusiveProps = ['getMessage', 'error', 'action', 'onError', 'onClose'];

    this.onClose = function (reason) {
        return _this3.props.onClose(reason, _this3.props.error, _this3.props.action);
    };
};

exports.default = ErrorReporting;
